import {AuthRequest} from '../../interfaces/core/auth-request';

export class AuthRequestFactory {

  public static toRemote(auth: AuthRequest): any {

    return {
      username: auth.username,
      password: auth.password,
      device_name: auth.deviceName
    };

  }

}
